var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{ref:"uploadExcel",attrs:{"disabled":_vm.disabled,"auto-upload":false,"accept":".xlsx, .xls ,.csv,.xlsb","on-change":_vm.fileChange,"show-file-list":false,"action":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }